import { configureStore, combineReducers } from '@reduxjs/toolkit'
import thunk from 'redux-thunk';
import patientReducer from '../reducers/patientReducers';
import userAuthReducer from '../reducers/userAuthReducer';
import patientReducer1 from '../reducers/sideBarReducer';

const appStore = combineReducers({
  prescriptions: patientReducer,
  user: userAuthReducer,
  sideBar: patientReducer1,
});

const store = configureStore({
  reducer: { appStore },
  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(thunk),
  devTools: process.env.NODE_ENV !== 'production',
  // preloadedState,
  // enhancers: [batchedSubscribe(debounceNotify)],
})

export default store;
